import { z } from "zod";

import { providerIntegrationProviderSchema } from "../commons/providerIdentity";
import {
  providerIntegrationOperationActionSchema,
  providerIntegrationOperationActorSchema,
  providerIntegrationOperationResourceTypeSchema,
  providerIntegrationOperationSchema,
  providerIntegrationOperationSourceSchema,
} from "../commons/providerIntegrationOperation";

export const createProviderIntegrationOperationBodySchema = z.object({
  provider: providerIntegrationProviderSchema,
  resourceType: providerIntegrationOperationResourceTypeSchema,
  action: providerIntegrationOperationActionSchema,
  status: z.enum(["requested", "pending"]).optional(),
  idempotencyKey: z.string().optional(),
  targetId: z.string().optional(),
  requestPayload: z.record(z.unknown()),
  requestedBy: providerIntegrationOperationActorSchema.optional(),
  executedBy: providerIntegrationOperationActorSchema.optional(),
  source: providerIntegrationOperationSourceSchema,
});

export const createProviderIntegrationOperationRequestSchema = z.object({
  body: createProviderIntegrationOperationBodySchema,
  query: z.object({}).optional(),
  params: z.object({}).optional(),
});

export const getProviderIntegrationOperationRequestSchema = z.object({
  body: z.object({}).optional(),
  query: z.object({}).optional(),
  params: z.object({
    operationId: z.string().min(1),
  }),
});

export const providerIntegrationOperationResponseSchema = z.object({
  operation: providerIntegrationOperationSchema.extend({
    _id: z.unknown().optional(),
  }),
});

export type CreateProviderIntegrationOperationBody = z.infer<
  typeof createProviderIntegrationOperationBodySchema
>;
